import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Barrier extends Modifier {
  static readonly baseTitle = 'Barrier';
  static readonly baseText =
    'Reduce stacks by the damage value, then reduce damage value by the same amount.';
  static readonly baseIcon = 'barrier';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Early;

  // Instance properties that can change
  title = Barrier.baseTitle;
  text = Barrier.baseText;
  icon = Barrier.baseIcon;
  tags: Array<ModifierTags> = [...Barrier.baseTags];
  priority = Barrier.basePriority;

  damageIn(damage: Damage) {
    let difference = this.stacks - damage.value;
    this.removeStacks(Math.min(this.stacks, damage.value));

    if (difference >= 0) {
      damage.value = 0;
    } else {
      damage.value = Math.abs(difference);
    }
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Barrier, Barrier);
